import { useState } from 'react';
import { Avatar, Tabs, Empty, Button, Switch, Input, message } from 'antd';
import { EditOutlined, ShareAltOutlined, UserOutlined, SettingOutlined, DollarOutlined, BookOutlined, FileTextOutlined, HeartOutlined, PictureOutlined } from '@ant-design/icons';

const creditRecords = [
  { date: '今天 09:16', amount: '+10', desc: '登录额度赠送', type: 'daily' },
  { date: '2026-08-01 00:00', amount: '-10', desc: '每日额度过期', type: 'expire' },
  { date: '2026-07-31 14:22', amount: '-10', desc: 'AI对话 x2', type: 'consume' },
  { date: '2026-07-31 09:16', amount: '+10', desc: '登录额度赠送', type: 'daily' },
  { date: '2026-07-29 18:45', amount: '-5', desc: '图片生成 x1', type: 'consume' },
  { date: '2026-07-28 09:16', amount: '+10', desc: '登录额度赠送', type: 'daily' },
];

const myPosts = [
  { id: 1, title: 'Simon\'s Cat 品牌升级方案', likes: 8, type: '品牌视觉' },
  { id: 2, title: '咖啡节海报设计', likes: 15, type: '海报设计' },
  { id: 3, title: 'TikTok种草脚本', likes: 6, type: '活动策划' },
];

const ProfilePage = () => {
  const [removeWatermark, setRemoveWatermark] = useState(false);
  const [nickname, setNickname] = useState('');
  const [bio, setBio] = useState('');

  return (
    <div style={{ maxWidth: 900, margin: '0 auto', padding: '32px' }}>
      {/* Profile Card */}
      <div className="glass-card" style={{ padding: '32px', marginBottom: 32 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 20, marginBottom: 24 }}>
          <Avatar size={72} style={{ background: 'var(--gradient-brand)', fontSize: 28 }}>
            灵
          </Avatar>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 20, fontWeight: 600, color: '#fff', marginBottom: 4 }}>
              166****0215
            </div>
            <div style={{ fontSize: 13, color: 'var(--text-tertiary)' }}>加入于 2026年7月</div>
          </div>
          <Button icon={<EditOutlined />} style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)', color: '#fff' }}>
            编辑信息
          </Button>
          <Button icon={<ShareAltOutlined />} style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)', color: '#fff' }}>
            分享主页
          </Button>
        </div>

        {/* Tabs */}
        <Tabs
          defaultActiveKey="posts"
          items={[
            {
              key: 'posts',
              label: <span><FileTextOutlined /> 我的发布 <span style={{ color: 'var(--text-tertiary)' }}>({myPosts.length})</span></span>,
              children: (
                <div>
                  <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
                    <button style={{ padding: '4px 12px', borderRadius: 16, background: 'rgba(102,126,234,0.15)', border: '1px solid rgba(102,126,234,0.3)', color: '#fff', fontSize: 12, cursor: 'pointer' }}>
                      图片
                    </button>
                    <button style={{ padding: '4px 12px', borderRadius: 16, background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)', color: 'var(--text-tertiary)', fontSize: 12, cursor: 'pointer' }}>
                      策划
                    </button>
                  </div>
                  {myPosts.length > 0 ? (
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 }}>
                      {myPosts.map((post) => (
                        <div key={post.id} className="glass-card hover-lift" style={{ overflow: 'hidden', cursor: 'pointer' }}>
                          <div className="skeleton-card" style={{ aspectRatio: '4/3', background: 'linear-gradient(135deg, rgba(102,126,234,0.12), rgba(118,75,162,0.12))', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'rgba(255,255,255,0.15)', fontSize: 24 }}>
                            <PictureOutlined />
                          </div>
                          <div style={{ padding: 10 }}>
                            <div style={{ fontSize: 13, color: '#fff', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{post.title}</div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 4 }}>
                              <span style={{ fontSize: 11, color: 'var(--text-tertiary)' }}>{post.type}</span>
                              <span style={{ fontSize: 11, color: 'var(--text-secondary)' }}>❤️ {post.likes}</span>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <Empty description={<span style={{ color: 'var(--text-tertiary)' }}>还没有发布内容</span>} style={{ padding: '40px 0' }} />
                  )}
                </div>
              ),
            },
            {
              key: 'likes',
              label: <span><HeartOutlined /> 我的喜欢 <span style={{ color: 'var(--text-tertiary)' }}>(34)</span></span>,
              children: (
                <div style={{ textAlign: 'center', padding: '60px 0' }}>
                  <HeartOutlined style={{ fontSize: 48, color: 'var(--text-tertiary)', marginBottom: 16 }} />
                  <div style={{ color: 'var(--text-secondary)', marginBottom: 12 }}>你还没有喜欢的内容</div>
                  <div style={{ color: 'var(--text-tertiary)', fontSize: 13, marginBottom: 20 }}>
                    去广场逛逛，把感兴趣的作品收藏到这里
                  </div>
                  <button className="btn-gradient" onClick={() => { window.location.href = '/community'; }}>
                    去广场看看
                  </button>
                </div>
              ),
            },
          ]}
        />
      </div>

      {/* Settings Section */}
      <div className="glass-card" style={{ padding: '24px', marginBottom: 24 }}>
        <h3 style={{ fontSize: 16, fontWeight: 600, color: '#fff', marginBottom: 20 }}>
          <SettingOutlined style={{ marginRight: 8, color: 'var(--text-secondary)' }} />订阅与积分
        </h3>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24, padding: '16px 0', borderBottom: '1px solid var(--border-subtle)' }}>
          <div>
            <div style={{ color: '#fff', fontSize: 14, fontWeight: 500, marginBottom: 4 }}>会员套餐</div>
            <div style={{ color: 'var(--text-tertiary)', fontSize: 12 }}>免费用户 · 每日赠送10积分</div>
          </div>
          <button className="btn-gradient" style={{ height: 36, padding: '0 16px', fontSize: 13 }}>升级套餐</button>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, marginBottom: 24 }}>
          {[
            { label: '总积分', value: 59, color: '#fff' },
            { label: '免费积分', value: 10, color: 'var(--success)' },
            { label: '充值积分', value: 49, color: 'var(--brand-gold)' },
          ].map((item) => (
            <div key={item.label} style={{ textAlign: 'center', padding: '12px 0', background: 'rgba(255,255,255,0.02)', borderRadius: 10 }}>
              <div style={{ fontSize: 24, fontWeight: 700, color: item.color }}>{item.value}</div>
              <div style={{ fontSize: 12, color: 'var(--text-tertiary)' }}>{item.label}</div>
            </div>
          ))}
        </div>

        {/* Credit Records */}
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ textAlign: 'left', padding: '8px 0', color: 'var(--text-tertiary)', fontSize: 12, fontWeight: 400 }}>日期</th>
              <th style={{ textAlign: 'center', padding: '8px 0', color: 'var(--text-tertiary)', fontSize: 12, fontWeight: 400 }}>变动</th>
              <th style={{ textAlign: 'right', padding: '8px 0', color: 'var(--text-tertiary)', fontSize: 12, fontWeight: 400 }}>说明</th>
            </tr>
          </thead>
          <tbody>
            {creditRecords.map((r, idx) => (
              <tr key={idx} style={{ borderTop: '1px solid var(--border-subtle)' }}>
                <td style={{ padding: '10px 0', fontSize: 13, color: 'var(--text-secondary)' }}>{r.date}</td>
                <td style={{ padding: '10px 0', textAlign: 'center', fontSize: 13, fontWeight: 600, color: r.amount.startsWith('+') ? 'var(--success)' : 'var(--text-secondary)' }}>
                  {r.amount}
                </td>
                <td style={{ padding: '10px 0', textAlign: 'right', fontSize: 13, color: 'var(--text-secondary)' }}>{r.desc}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Generation Settings */}
      <div className="glass-card" style={{ padding: '24px', marginBottom: 24 }}>
        <h3 style={{ fontSize: 16, fontWeight: 600, color: '#fff', marginBottom: 20 }}>生图设置</h3>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <div style={{ flex: 1 }}>
            <div style={{ color: '#fff', fontSize: 14, fontWeight: 500, marginBottom: 8 }}>去除水印</div>
            <p style={{ color: 'var(--text-tertiary)', fontSize: 12, lineHeight: 1.6, maxWidth: 500 }}>
              根据法律法规要求，西蒙的猫AI在提供AI生成合成服务时，可能导致公众混淆或者误认的，平台应当在AI生成合成内容上添加显式标识。打开开关后下载图片不再添加"AI生成"标呐。
            </p>
          </div>
          <div
            className={`toggle-switch ${removeWatermark ? 'active' : ''}`}
            onClick={() => setRemoveWatermark(!removeWatermark)}
            role="switch"
            aria-checked={removeWatermark}
            tabIndex={0}
            onKeyDown={(e) => { if (e.key === 'Enter') setRemoveWatermark(!removeWatermark); }}
          >
            <div className="toggle-switch-knob" />
          </div>
        </div>
      </div>

      {/* Account Deletion */}
      <div className="glass-card" style={{ padding: '24px' }}>
        <h3 style={{ fontSize: 16, fontWeight: 600, color: '#fff', marginBottom: 12 }}>账号管理</h3>
        <p style={{ color: 'var(--text-tertiary)', fontSize: 12, marginBottom: 16 }}>
          注销后账号将立即停止使用，个人信息随后异步清理。此操作不可恢复。
        </p>
        <button style={{
          padding: '8px 20px', borderRadius: 8,
          background: 'rgba(252,129,129,0.1)',
          border: '1px solid rgba(252,129,129,0.2)',
          color: 'var(--error)', fontSize: 13, cursor: 'pointer',
        }}>
          注销账号
        </button>
      </div>
    </div>
  );
};

export default ProfilePage;
